import moment from "moment";

const EFFECTIVE_DATE_FORMAT = "MM-DD-YYYY";
const NEW_BUSINESS_RULES_EFFECTIVE_DATE = moment("09-01-2026", EFFECTIVE_DATE_FORMAT);
export const LANDLORD_QUOTE_UNAVAILABLE_DATE = moment("09-01-2027", EFFECTIVE_DATE_FORMAT);

export const LANDLORD_QUOTE_UNAVAILABLE_MESSAGE =
  "Landlord quotes effective September 1, 2027 or later are temporarily unavailable.";

export function getIsNewBusinessRulesEffective(effectiveDate?: string) {
  if (!effectiveDate) return false;

  const selectedEffectiveDate = moment(effectiveDate, EFFECTIVE_DATE_FORMAT, true);
  if (!selectedEffectiveDate.isValid()) return false;

  return selectedEffectiveDate.isSameOrAfter(NEW_BUSINESS_RULES_EFFECTIVE_DATE, "day");
}

export function getIsLandlordQuoteUnavailable(effectiveDate?: string) {
  if (!effectiveDate) return false;

  const selectedEffectiveDate = moment(effectiveDate, EFFECTIVE_DATE_FORMAT, true);
  if (!selectedEffectiveDate.isValid()) return false;

  return selectedEffectiveDate.isSameOrAfter(LANDLORD_QUOTE_UNAVAILABLE_DATE, "day");
}
